<template>
  <div class="md-select-search-wrapper">
    <md-select
      class="md-select-item"
      v-bind="$attrs"
      v-on="$listeners"
      :value="value"
      multiple
      @input="$emit('input', $event)"
      @md-opened="onSelectFocus"
      @md-closed="onSelectBlur"
    >
      <div class="md-select-search" v-if="isSelectOpen">
        <v-field>
          <v-input
            v-model="search"
            placeholder="Išči..."
            @click.stop
            size="small"
            @input="filterOptions"
            ref="input"
          />
        </v-field>
      </div>
      <md-option
        v-for="option in filteredOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </md-option>

      <div v-if="filteredOptions.length === 0" class="no-results">
        Ni rezultatov
      </div>
    </md-select>
  </div>
</template>

<script>
import VInput from 'design-system/VInput.vue'
import VField from 'design-system/VField.vue'

export default {
  inheritAttrs: false,
  components: { VInput, VField },
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, required: true },
  },
  data () {
    return {
      isSelectOpen: false,
      search: '',
      filteredOptions: this.options,
    }
  },
  watch: {
    options (newOptions) {
      this.filteredOptions = this.filterByTerm(newOptions, this.search)
    },
  },
  methods: {
    filterOptions () {
      this.filteredOptions = this.filterByTerm(this.options, this.search)
    },
    filterByTerm (options, term) {
      const t = term.trim().toLowerCase()
      if (!t || t === '') {
        return options
      }
      return options.filter(o => (o.label || '').toLowerCase().includes(t))
    },
    onSelectFocus () {
      // For some reason, md-select positioning gets messed up if we display the input (isSelectOpen) immediately or on next tick :/
      setTimeout(() => {
        this.isSelectOpen = true
        this.$nextTick(() => this.$refs.input.focus())
      }, 250)
    },
    onSelectBlur () {
      this.isSelectOpen = false
      this.search = ''
      this.filterOptions()
    },
  },
}
</script>

<style lang="scss" scoped>
.md-select-search-wrapper {
  width: 100%;
}

.md-select-search {
  padding: 0 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  ::v-deep  .md-field {
    padding: 0;
    margin: 0 0 8px 0;
  }
}

.no-results {
  padding: 16px;
  font-size: 14px;
}
</style>
